import axios from 'axios';
import errorMessage from './errorMessage';
import {
  GET_TRIBUN_NOTIFICATION_COUNT_REQUEST,
  GET_TRIBUN_NOTIFICATION_COUNT_SUCCESS,
  GET_TRIBUN_NOTIFICATION_COUNT_FAILURE,

  GET_TRIBUN_ANOTHER_USER_REQUEST,
  GET_TRIBUN_ANOTHER_USER_SUCCESS,
  GET_TRIBUN_ANOTHER_USER_FAILURE,

  GET_TRIBUN_LAST_WIN_LOST_COUPONS_REQUEST,
  GET_TRIBUN_LAST_WIN_LOST_COUPONS_SUCCESS,
  GET_TRIBUN_LAST_WIN_LOST_COUPONS_FAILURE,

  GET_PROFIL_TRIBUN_COUPONS_REQUEST,
  GET_PROFIL_TRIBUN_COUPONS_SUCCESS,
  GET_PROFIL_TRIBUN_COUPONS_FAILURE,
  GET_PROFIL_TRIBUN_COUPONS_INITIAL_STATE,

  GET_TRIBUN_FOLLOWINGS_REQUEST,
  GET_TRIBUN_FOLLOWINGS_SUCCESS,
  GET_TRIBUN_FOLLOWINGS_FAILURE,

  GET_TRIBUN_FOLLOWERS_REQUEST,
  GET_TRIBUN_FOLLOWERS_SUCCESS,
  GET_TRIBUN_FOLLOWERS_FAILURE,

  RESET_TRIBUN_PROFILE,

  SHOW_OR_HIDE_CHECKBOX_TRIBUN_COUPONS_REQUEST,
  SHOW_OR_HIDE_CHECKBOX_TRIBUN_COUPONS_SUCCESS,
  SHOW_OR_HIDE_CHECKBOX_TRIBUN_COUPONS_FAILURE,

  GET_TRIBUN_NOTIFICATIONS_REQUEST,
  GET_TRIBUN_NOTIFICATIONS_SUCCESS,
  GET_TRIBUN_NOTIFICATIONS_FAILURE,
  GET_TRIBUN_NOTIFICATIONS_INITIAL_STATE,

  GET_MINI_LEADERBOARD_SCORE_LIST_REQUEST,
  GET_MINI_LEADERBOARD_SCORE_LIST_SUCCESS,
  GET_MINI_LEADERBOARD_SCORE_LIST_FAILURE,

  SET_PIN_FEED_REQUEST,
  SET_PIN_FEED_SUCCESS,
  SET_PIN_FEED_FAILURE,

  REMOVE_PIN_FEED_REQUEST,
  REMOVE_PIN_FEED_SUCCESS,
  REMOVE_PIN_FEED_FAILURE,

  GET_PINNED_FEED_REQUEST,
  GET_PINNED_FEED_SUCCESS,
  GET_PINNED_FEED_FAILURE,

  GET_TRIBUN_NOTIFICATION_REQUEST,
  GET_TRIBUN_NOTIFICATION_SUCCESS,
  GET_TRIBUN_NOTIFICATION_FAILURE,

  GET_TRIBUN_BLOCKED_USERS_REQUEST,
  GET_TRIBUN_BLOCKED_USERS_SUCCESS,
  GET_TRIBUN_BLOCKED_USERS_FAILURE,

  GET_TRIBUN_PUSH_FOLLOWING_USERS_REQUEST,
  GET_TRIBUN_PUSH_FOLLOWING_USERS_SUCCESS,
  GET_TRIBUN_PUSH_FOLLOWING_USERS_FAILURE,

  EDIT_TRIBUN_NOTIFICATION_REQUEST,
  EDIT_TRIBUN_NOTIFICATION_SUCCESS,
  EDIT_TRIBUN_NOTIFICATION_FAILURE,

  GET_PUSH_FOLLOW_REQUEST,
  GET_PUSH_FOLLOW_SUCCESS,
  GET_PUSH_FOLLOW_FAILURE,

  GET_PUSH_UNFOLLOW_REQUEST,
  GET_PUSH_UNFOLLOW_SUCCESS,
  GET_PUSH_UNFOLLOW_FAILURE,

  GET_USER_PUSH_COUNT_REQUEST,
  GET_USER_PUSH_COUNT_SUCCESS,
  GET_USER_PUSH_COUNT_FAILURE,

  GET_USER_TRIBUN_BLOCK_REQUEST,
  GET_USER_TRIBUN_BLOCK_SUCCESS,
  GET_USER_TRIBUN_BLOCK_FAILURE,

  GET_USER_TRIBUN_UNBLOCK_REQUEST,
  GET_USER_TRIBUN_UNBLOCK_SUCCESS,
  GET_USER_TRIBUN_UNBLOCK_FAILURE,

  GET_BLOCK_USER_COUNT_REQUEST,
  GET_BLOCK_USER_COUNT_SUCCESS,
  GET_BLOCK_USER_COUNT_FAILURE,

  GET_MUTED_USER_COUNT_REQUEST,
  GET_MUTED_USER_COUNT_SUCCESS,
  GET_MUTED_USER_COUNT_FAILURE,

  GET_TRIBUN_MUTED_USERS_REQUEST,
  GET_TRIBUN_MUTED_USERS_SUCCESS,
  GET_TRIBUN_MUTED_USERS_FAILURE,
  GET_TRIBUN_MUTED_USERS_RESET,

  GET_TRIBUN_PUSH_FOLLOWING_USERS_RESET,
  GET_TRIBUN_BLOCKED_USERS_RESET,
  SET_ACTIVE_SEGMENT

} from 'Store/constants';

import clone from 'lodash/clone';
import LocalStorage from 'Utils/localStorage';
import { openModal } from 'Store/actions';
import ProjectConfig from 'ProjectConfig';

const getDateRange = filterName => {
  let dateRange = 'WEEK';
  switch (filterName) {
    case 'WEEK':
      dateRange = 'WEEK';
      break;
    case 'MONTH':
      dateRange = 'MONTH';
      break;
    case 'FOUR_MONTH':
      dateRange = 'FOUR_MONTH';
      break;
    default:
      break;
  }
  return { dateRange };
};

const API_GATEWAY = ProjectConfig.API_GATEWAY;

const tribunFeedsRequestData = {
  max: 500000,
  sortField: 'date',
  sortOrder: 'DESC',
  coupon: 'all',
  count: 30,
  channel: '0',
  filterCount: '0',
  canBet: true,
  resultToday: false,
  category: 'both',
  min: 1,
  longTerm: false,
};

import { replaceUrlWithPublicUrl } from 'Utils/replaceUrlWithPublicUrl';

export const getTribunNotificationCount = () => async (dispatch, getState) => {

  try {
    dispatch({
      type: GET_TRIBUN_NOTIFICATION_COUNT_REQUEST
    });

    const res = await axios({
      url: `${API_GATEWAY}/v2/mobile/tribun/notifications/poll`,
      method: 'get',
      headers: {
        channel: '0'
      }
    });

    dispatch({
      type: GET_TRIBUN_NOTIFICATION_COUNT_SUCCESS,
      payload: res.data
    });

  } catch (e) {
    dispatch({
      type: GET_TRIBUN_NOTIFICATION_COUNT_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};


export const getUserPushCount = () => async (dispatch, getState) => {

  try {
    dispatch({
      type: GET_USER_PUSH_COUNT_REQUEST
    });


    const res = await axios({
      method: 'GET',
      url: `${API_GATEWAY}/v2/mobile/tribun/count/pushFollowings`,
      headers: {
        channel: '0',
      }
    });

    dispatch({
      type: GET_USER_PUSH_COUNT_SUCCESS,
      payload: res.data
    });
  } catch (e) {
    dispatch({
      type: GET_USER_PUSH_COUNT_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const getTribunAnotherUser = tribunUserId => async (dispatch, getState) => {

  const user = getState().auth.data;
  const body = {
    channel: '0',
    userid: tribunUserId
  };

  try {
    dispatch({
      type: GET_TRIBUN_ANOTHER_USER_REQUEST
    });

    const res = await axios({
      url: replaceUrlWithPublicUrl(user, `${API_GATEWAY}/v2/mobile/tribun/user/anotheruser?userid=${tribunUserId}`),
      data: body,
      method: 'get',
      headers: {
        channel: '0'
      }
    });

    dispatch({
      type: GET_TRIBUN_ANOTHER_USER_SUCCESS,
      payload: res.data.tribunUser
    });

  } catch (e) {
    dispatch({
      type: GET_TRIBUN_ANOTHER_USER_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const getLastWinLostCoupons = tribunUserId => async (dispatch, getState) => {

  const user = getState().auth.data;

  try {
    dispatch({
      type: GET_TRIBUN_LAST_WIN_LOST_COUPONS_REQUEST
    });

    const res = await axios({
      url: replaceUrlWithPublicUrl(user, `${API_GATEWAY}/v2/mobile/tribun/feed/last-win-lost/?userId=${tribunUserId}`),
      method: 'get',
      headers: {
        channel: '0'
      }
    });
    dispatch({
      type: GET_TRIBUN_LAST_WIN_LOST_COUPONS_SUCCESS,
      payload: res.data.statuses
    });

  } catch (e) {
    dispatch({
      type: GET_TRIBUN_LAST_WIN_LOST_COUPONS_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const getPushFollow = (tribunUserId, tabType, tribunUserName) => async (dispatch, getState) => {

  try {
    dispatch({
      type: GET_PUSH_FOLLOW_REQUEST
    });

    const res = await axios({
      url: `${API_GATEWAY}/v2/mobile/tribun/push/follow?userid=${tribunUserId}`,
      method: 'get',
      headers: {
        channel: '0',
      }
    });
    dispatch({
      type: GET_PUSH_FOLLOW_SUCCESS,
      payload: res.data.statuses,
      tabType: tabType,
      username: tribunUserName
    });

  } catch (e) {
    dispatch({
      type: GET_PUSH_FOLLOW_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const getPushUnfollow = (tribunUserId, tabType, tribunUserName) => async (dispatch, getState) => {


  try {
    dispatch({
      type: GET_PUSH_UNFOLLOW_REQUEST
    });

    const res = await axios({
      url: `${API_GATEWAY}/v2/mobile/tribun/push/unfollow?userid=${tribunUserId}`,
      method: 'get',
      headers: {
        channel: '0',
      }
    });
    dispatch({
      type: GET_PUSH_UNFOLLOW_SUCCESS,
      payload: res.data.statuses,
      tabType: tabType,
      username: tribunUserName
    });

  } catch (e) {
    dispatch({
      type: GET_PUSH_UNFOLLOW_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const getBlockUserCount = () => async (dispatch, getState) => {

  try {
    dispatch({
      type: GET_BLOCK_USER_COUNT_REQUEST,
    });

    const res = await axios({
      url: `${API_GATEWAY}/v2/mobile/tribun/blocked-users/by-user/count`,
      method: 'get',
      headers: {
        channel: '0',
      }
    });
    dispatch({
      type: GET_BLOCK_USER_COUNT_SUCCESS,
      payload: res.data
    });

  } catch (e) {
    dispatch({
      type: GET_BLOCK_USER_COUNT_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const getMutedUserCount = () => async (dispatch, getState) => {

  try {
    dispatch({
      type: GET_MUTED_USER_COUNT_REQUEST,
    });

    const res = await axios({
      url: `${API_GATEWAY}/v2/mobile/tribun/user/mutes/count`,
      method: 'get',
      headers: {
        channel: '0',
      }
    });
    dispatch({
      type: GET_MUTED_USER_COUNT_SUCCESS,
      payload: res.data
    });

  } catch (e) {
    dispatch({
      type: GET_MUTED_USER_COUNT_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const setActiveSegment = segment => ({
  type: SET_ACTIVE_SEGMENT,
  payload: segment,
});

const fetchPastFeed = (url, requestBody, dateRange) => axios.post(url,
  {
    ...requestBody, offset: undefined, canBet: false, pinned: false, ...getDateRange(dateRange),
  },
  {
    headers: {
      channel: '0'
    }
  });

export const getMyTribunCoupons = (tribunUserId, offset, section, dateRange) => async (dispatch, getState) => {
  const url = `${API_GATEWAY}/v2/mobile/tribun/feed/me`;
  try {
    const requestBody = clone(tribunFeedsRequestData);

    if (LocalStorage.get('tribunHeaderSortOptions') && LocalStorage.get('tribunHeaderSortOptions').profile) {
      requestBody.sortField = LocalStorage.get('tribunHeaderSortOptions').profile.sortField;
      requestBody.sortOrder = LocalStorage.get('tribunHeaderSortOptions').profile.sortOrder;
    }

    if (offset) {
      requestBody.offset = offset;
    }


    if (!offset) {
      dispatch({
        type: GET_PROFIL_TRIBUN_COUPONS_INITIAL_STATE
      });
    }

    dispatch({
      type: GET_PROFIL_TRIBUN_COUPONS_REQUEST
    });

    if (section === 'past') {
      const pastBets = await axios.post(url,
        {
          ...requestBody, canBet: false, pinned: false, ...getDateRange(dateRange),
        },
        {
          headers: {
            channel: '0'
          }
        });

      dispatch({
        type: GET_PROFIL_TRIBUN_COUPONS_SUCCESS,
        past: pastBets.data.feeds,
        lastPage: pastBets.data.lastPage
      });

      if (!pastBets.data.feeds.length) {
        return dispatch({
          type: GET_PROFIL_TRIBUN_COUPONS_FAILURE,
          lastPage: true,
          isCurrentUser: true
        });
      }

      return;
    }

    const todayBets = await axios.post(url,
      {
        ...requestBody, canBet: true, count: 30, pinned: false,
      },
      {
        headers: {
          channel: '0'
        }
      });

    dispatch({
      type: GET_PROFIL_TRIBUN_COUPONS_SUCCESS,
      today: todayBets.data.feeds || [],
      todayLastPage: todayBets.data.lastPage
    });

    if (todayBets.data.lastPage) {
      const pastBets = await fetchPastFeed(url, requestBody, dateRange);

      dispatch({
        type: GET_PROFIL_TRIBUN_COUPONS_SUCCESS,
        past: pastBets.data.feeds,
        lastPage: pastBets.data.lastPage
      });

      if (!pastBets.data.feeds.length) {
        return dispatch({
          type: GET_PROFIL_TRIBUN_COUPONS_FAILURE,
          lastPage: true,
          isCurrentUser: true
        });
      }
    }

  } catch (e) {
    dispatch({
      type: GET_PROFIL_TRIBUN_COUPONS_FAILURE,
      payload: e.response && e.response.data || errorMessage,
      lastPage: true,
      todayLastPage: true
    });
  }
};

export const getAnotherTribunCoupons = (tribunUserId, offset, section, dateRange) => async (dispatch, getState) => {
  try {
    const user = getState().auth.data;
    const url = replaceUrlWithPublicUrl(user, `${API_GATEWAY}/v2/mobile/tribun/feed/anotheruser`);
    const requestBody = clone(tribunFeedsRequestData);
    requestBody.userId = +tribunUserId;

    if (LocalStorage.get('tribunHeaderSortOptions') && LocalStorage.get('tribunHeaderSortOptions').profile) {
      requestBody.sortField = LocalStorage.get('tribunHeaderSortOptions').profile.sortField;
      requestBody.sortOrder = LocalStorage.get('tribunHeaderSortOptions').profile.sortOrder;
    }

    if (offset) {
      requestBody.offset = offset;
    }

    if (!offset) {
      dispatch({
        type: GET_PROFIL_TRIBUN_COUPONS_INITIAL_STATE
      });
    }

    dispatch({
      type: GET_PROFIL_TRIBUN_COUPONS_REQUEST
    });

    if (section === 'past') {
      const pastBets = await axios.post(url,
        {
          ...requestBody, canBet: false, pinned: false, ...getDateRange(dateRange)
        },
        {
          headers: {
            channel: '0'
          }
        });

      dispatch({
        type: GET_PROFIL_TRIBUN_COUPONS_SUCCESS,
        past: pastBets.data.feeds,
        lastPage: pastBets.data.lastPage
      });

      if (!pastBets.data.feeds.length) {
        return dispatch({
          type: GET_PROFIL_TRIBUN_COUPONS_FAILURE,
          lastPage: true,
          isCurrentUser: false
        });
      }

      return;
    }

    const todayBets = await axios.post(url,
      {
        ...requestBody, canBet: true, count: 30, pinned: false
      },
      {
        headers: {
          channel: '0'
        }
      });

    dispatch({
      type: GET_PROFIL_TRIBUN_COUPONS_SUCCESS,
      today: todayBets.data.feeds || [],
      todayLastPage: todayBets.data.lastPage
    });

    if (todayBets.data.lastPage) {
      const pastBets = await fetchPastFeed(url, requestBody, dateRange);

      dispatch({
        type: GET_PROFIL_TRIBUN_COUPONS_SUCCESS,
        past: pastBets.data.feeds,
        lastPage: pastBets.data.lastPage
      });

      if (!pastBets.data.feeds.length) {
        return dispatch({
          type: GET_PROFIL_TRIBUN_COUPONS_FAILURE,
          lastPage: true,
          isCurrentUser: false
        });
      }
    }

  } catch (e) {
    dispatch({
      type: GET_PROFIL_TRIBUN_COUPONS_FAILURE,
      payload: e.response && e.response.data || errorMessage,
      lastPage: true,
      todayLastPage: true
    });
  }
};

export const getTribunFollowings = (userId, offset) => async (dispatch, getState) => {
  try {
    const tribunFeedsRequestData = {
      offset: '',
      userId: ''
    };

    if (offset) {
      clone(tribunFeedsRequestData).offset = offset;
    } else {
      offset = '';
    }

    if (userId) {
      clone(tribunFeedsRequestData).userId = userId;
    } else {
      userId = '';
    }

    dispatch({
      type: GET_TRIBUN_FOLLOWINGS_REQUEST
    });

    let count = 15;


    const res = await axios({
      url: `${API_GATEWAY}/v2/mobile/tribun/followings?count=${count}&offset=${offset}&uid=${userId}`,
      method: 'get',
      headers: {
        channel: '0'
      }
    });

    if (!res.data.users.length) {
      return dispatch({
        type: GET_TRIBUN_FOLLOWINGS_FAILURE,
        lastPage: true
      });
    }

    dispatch({
      type: GET_TRIBUN_FOLLOWINGS_SUCCESS,
      payload: res.data,
      lastPage: res.data.users.length < count
    });

  } catch (e) {
    dispatch({
      type: GET_TRIBUN_FOLLOWINGS_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};
export const getTribunFollowers = (userId, offset) => async (dispatch, getState) => {
  try {
    const tribunFeedsRequestData = {
      offset: '',
      userId: ''
    };

    if (offset) {
      clone(tribunFeedsRequestData).offset = offset;
    } else {
      offset = '';
    }

    if (userId) {
      clone(tribunFeedsRequestData).userId = userId;
    } else {
      userId = '';
    }

    dispatch({
      type: GET_TRIBUN_FOLLOWERS_REQUEST
    });

    let count = 15;


    const res = await axios({
      url: `${API_GATEWAY}/v2/mobile/tribun/followers?count=${count}&offset=${offset}&uid=${userId}`,
      method: 'get',
      headers: {
        channel: '0'
      }
    });

    if (!res.data.users.length) {
      return dispatch({
        type: GET_TRIBUN_FOLLOWERS_FAILURE,
        lastPage: true
      });
    }

    dispatch({
      type: GET_TRIBUN_FOLLOWERS_SUCCESS,
      payload: res.data,
      lastPage: res.data.users.length < count
    });

  } catch (e) {
    dispatch({
      type: GET_TRIBUN_FOLLOWERS_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const getTribunPushFollowings = (userId, offset) => async (dispatch, getState) => {
  try {

    const tribunFeedsRequestData = {
      offset: '',
      userId: ''
    };

    if (offset) {
      clone(tribunFeedsRequestData).offset = offset;
    } else {
      offset = '';
    }

    if (userId) {
      clone(tribunFeedsRequestData).userId = userId;
    } else {
      userId = '';
    }

    dispatch({
      type: GET_TRIBUN_PUSH_FOLLOWING_USERS_REQUEST
    });

    let count = 15;

    const res = await axios({
      url: `${API_GATEWAY}/v2/mobile/tribun/pushFollowings?count=${count}&offset=${offset}`,
      method: 'get',
      headers: {
        channel: '0',
      }
    });

    dispatch({
      type: GET_TRIBUN_PUSH_FOLLOWING_USERS_SUCCESS,
      payload: res.data,
      lastPage: res.data.users.length < count
    });


  } catch (e) {
    dispatch({
      type: GET_TRIBUN_PUSH_FOLLOWING_USERS_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};


export const getTribunBlockedUsers = (userId, offset) => async (dispatch, getState) => {
  try {
    const tribunFeedsRequestData = {
      offset: '',
      userId: ''
    };

    if (offset) {
      clone(tribunFeedsRequestData).offset = offset;
    } else {
      offset = '';
    }

    if (userId) {
      clone(tribunFeedsRequestData).userId = userId;
    } else {
      userId = '';
    }

    dispatch({
      type: GET_TRIBUN_BLOCKED_USERS_REQUEST
    });

    let count = 15;

    const res = await axios({
      url: `${API_GATEWAY}/v2/mobile/tribun/blocked-users/by-user?count=${count}&offset=${offset}`,
      method: 'get',
      headers: {
        channel: '0',
      }
    });

    dispatch({
      type: GET_TRIBUN_BLOCKED_USERS_SUCCESS,
      payload: res.data,
      lastPage: res.data.users.length < count
    });

  } catch (e) {
    dispatch({
      type: GET_TRIBUN_BLOCKED_USERS_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const getTribunMutedUsers = (userId, offset) => async (dispatch, getState) => {
  try {
    const tribunFeedsRequestData = {
      offset: '',
      userId: ''
    };

    if (offset) {
      clone(tribunFeedsRequestData).offset = offset;
    } else {
      offset = '';
    }

    if (userId) {
      clone(tribunFeedsRequestData).userId = userId;
    } else {
      userId = '';
    }

    dispatch({
      type: GET_TRIBUN_MUTED_USERS_REQUEST
    });

    let count = 15;

    const res = await axios({
      url: `${API_GATEWAY}/v2/mobile/tribun/user/mutes?count=${count}&offset=${offset}`,
      method: 'get',
      headers: {
        channel: '0',
      }
    });

    dispatch({
      type: GET_TRIBUN_MUTED_USERS_SUCCESS,
      payload: res.data,
      lastPage: res.data.users.length < count
    });

  } catch (e) {
    dispatch({
      type: GET_TRIBUN_MUTED_USERS_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const resetTribunMutedUsers = () => dispatch => {
  dispatch({
    type: GET_TRIBUN_MUTED_USERS_RESET
  });
};

export const resetTribunProfile = () => dispatch => {
  dispatch({
    type: RESET_TRIBUN_PROFILE
  });
};


export const showOrHideCheckboxTribunCoupons = showHiddenCoupons => async (dispatch, getState) => {

  const preferences = getState().tribun.tribunUser.preferences;
  clone(preferences).profile.showHiddenCoupons = showHiddenCoupons;

  const body = {
    channel: '0',
    preferences: preferences
  };

  try {
    dispatch({
      type: SHOW_OR_HIDE_CHECKBOX_TRIBUN_COUPONS_REQUEST
    });

    const res = await axios({
      url: `${API_GATEWAY}/v2/mobile/tribun/user/preferences`,
      data: body,
      method: 'put',
      headers: {
        channel: '0'
      }
    });

    dispatch({
      type: SHOW_OR_HIDE_CHECKBOX_TRIBUN_COUPONS_SUCCESS,
      payload: res.data.tribunPreferences.preferences.notification
    });

  } catch (e) {

    dispatch({
      type: SHOW_OR_HIDE_CHECKBOX_TRIBUN_COUPONS_FAILURE,
      payload: errorMessage
    });
  }
};

export const getUserTribunNotifications = (following, offset) => async (dispatch, getState) => {
  try {

    const tribunFeedsRequestData = {
      followings: following,
      count: 10,
      offset: ''
    };

    const params = clone(tribunFeedsRequestData);

    if (offset) {
      params.offset = offset;
    }

    if (!offset) {
      dispatch({
        type: GET_TRIBUN_NOTIFICATIONS_INITIAL_STATE
      });
    }

    dispatch({
      type: GET_TRIBUN_NOTIFICATIONS_REQUEST
    });


    const res = await axios({
      url: `${API_GATEWAY}/v2/mobile/tribun/notifications`,
      method: 'get',
      headers: {
        channel: '0'
      },
      params: params
    });

    if (!res.data.notifications.length && offset) {
      return dispatch({
        type: GET_TRIBUN_NOTIFICATIONS_FAILURE,
        lastPage: true
      });
    }

    dispatch({
      type: GET_TRIBUN_NOTIFICATIONS_SUCCESS,
      payload: res.data.notifications,
      lastPage: res.data.notifications.length < params.count
    });

  } catch (e) {
    dispatch({
      type: GET_TRIBUN_NOTIFICATIONS_FAILURE,
      payload: errorMessage
    });
  }
};

// export const getUserTribunBlockUnblock = body => async (dispatch, getState) => {
//   try {
//     dispatch({
//       type: GET_USER_TRIBUN_BLOCK_UNBLOCK_REQUEST
//     });

//     const res = await axios({
//       url: `${API_GATEWAY}/v2/mobile/tribun/user/blockunblock?block=${body.block}&userid=${body.userid}`,
//       method: 'get',
//       headers: {
//         channel: '',
//       }
//     });

//     dispatch({
//       type: GET_USER_TRIBUN_BLOCK_UNBLOCK_SUCCESS,
//       payload: res.data
//     });
//     return res.data;
//   } catch (e) {
//     dispatch({
//       type: GET_USER_TRIBUN_BLOCK_UNBLOCK_FAILURE,
//       payload: e.response && e.response.data || errorMessage
//     });
//   }
// };

export const getUserTribunBlock = userid => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_USER_TRIBUN_BLOCK_REQUEST
    });

    const res = await axios({
      url: `${API_GATEWAY}/v2/mobile/tribun/block/by-user`,
      method: 'post',
      data: { block: true,
        userId: userid.toString() },
      headers: {
        channel: '',
      }
    });

    dispatch({
      type: GET_USER_TRIBUN_BLOCK_SUCCESS,
      payload: res.data
    });
    return res.data;
  } catch (e) {
    dispatch({
      type: GET_USER_TRIBUN_BLOCK_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const resetUserTribunNotifications = () => async dispatch => {
  dispatch({
    type: GET_TRIBUN_PUSH_FOLLOWING_USERS_RESET
  });
};

export const resetUserTribunBlock = () => async dispatch => {
  dispatch({
    type: GET_TRIBUN_BLOCKED_USERS_RESET
  });
};

export const getUserTribunUnblock = userid => async (dispatch, getState) => {
  try {

    dispatch({
      type: GET_USER_TRIBUN_UNBLOCK_REQUEST
    });


    const res = await axios({
      url: `${API_GATEWAY}/v2/mobile/tribun/unblock/by-user`,
      method: 'post',
      data: { block: false,
        userId: userid.toString()  },
      headers: {
        channel: '',
      }
    });

    dispatch({
      type: GET_USER_TRIBUN_UNBLOCK_SUCCESS,
      payload: res.data
    });
    return res.data;
  } catch (e) {
    dispatch({
      type: GET_USER_TRIBUN_UNBLOCK_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};


export const getNotificationSettings = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_TRIBUN_NOTIFICATION_REQUEST
    });

    const res = await axios({
      url: `${API_GATEWAY}/v2/mobile/tribun/user/preferences`,
      method: 'get',
      headers: {
        channel: '',
      }
    });

    dispatch({
      type: GET_TRIBUN_NOTIFICATION_SUCCESS,
      payload: res.data
    });
    return res.data;
  } catch (e) {
    dispatch({
      type: GET_TRIBUN_NOTIFICATION_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const editNotificationSettings = notifications => async (dispatch, getState) => {
  // NOTE: typo problem - notification would be notifications
  const preferences = {
    ...getState().tribun.tribunUser.preferences,
    notification: notifications
  };

  const body = {
    channel: '0',
    preferences: preferences,
    token: getState().tribun.userTribunToken.data
  };

  try {
    dispatch({
      type: EDIT_TRIBUN_NOTIFICATION_REQUEST
    });

    const res = await axios({
      url: `${API_GATEWAY}/v2/mobile/tribun/user/preferences`,
      data: body,
      method: 'put',
      headers: {
        channel: '0',
      }
    });

    dispatch({
      type: EDIT_TRIBUN_NOTIFICATION_SUCCESS,
      payload: res.data.tribunPreferences.preferences.notification
    });
    return res.data;
  } catch (e) {

    dispatch({
      type: EDIT_TRIBUN_NOTIFICATION_FAILURE,
      payload: errorMessage
    });
  }
};

export const getSortLeaderBoardMini = (currentUser, sortType) => async (dispatch, getState) => {

  try {

    dispatch({
      type: GET_MINI_LEADERBOARD_SCORE_LIST_REQUEST
    });

    const res = await axios({
      url: `${API_GATEWAY}/v2/mobile/tribun/leaderboard/scores/mini`,
      method: 'get',
      headers: {
        channel: '0'
      },
      scoreType: sortType,
    });

    dispatch({
      type: GET_MINI_LEADERBOARD_SCORE_LIST_SUCCESS,
      payload: res.data
    });

    dispatch(openModal('tribunLeaderBoardMiniSuccesModal', { data: res.data, currentUserId: currentUser }));

  } catch (e) {

    dispatch({
      type: GET_MINI_LEADERBOARD_SCORE_LIST_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });

    dispatch(openModal('tribunLeaderBoardMiniFailModal'));
  }
};

export const setPinFeed = (feedId, tabType, cb) => async (dispatch, getState) => {

  const body = {
    channel: '0',
    feedId: feedId
  };

  try {
    dispatch({
      type: SET_PIN_FEED_REQUEST
    });

    const res = await axios({
      url: `${API_GATEWAY}/v2/mobile/tribun/feed/pin`,
      data: body,
      method: 'patch',
      headers: {
        channel: '0'
      }
    });

    dispatch({
      type: SET_PIN_FEED_SUCCESS,
      payload: res.data,
      feedId: feedId,
      tabType: tabType,
    });

    if (cb) {
      dispatch(cb({ isPin: true }));
    }

  } catch (e) {
    dispatch({
      type: SET_PIN_FEED_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const removePinFeed = (feedId, tabType, cb) => async (dispatch, getState) => {

  const body = {
    channel: '0',
    feedId: feedId
  };

  try {
    dispatch({
      type: REMOVE_PIN_FEED_REQUEST
    });

    const res = await axios({
      url: `${API_GATEWAY}/v2/mobile/tribun/feed/unpin`,
      data: body,
      method: 'patch',
      headers: {
        channel: '0'
      }
    });

    dispatch({
      type: REMOVE_PIN_FEED_SUCCESS,
      payload: res.data,
      feedId: feedId,
      tabType: tabType,
    });

    if (cb) {
      dispatch(cb({ isPin: false }));
    }

  } catch (e) {
    dispatch({
      type: REMOVE_PIN_FEED_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const getPinnedFeed = userId => async (dispatch, getState) => {

  const body = {
    channel: '0',
    userId: userId
  };

  try {
    dispatch({
      type: GET_PINNED_FEED_REQUEST
    });

    const user = getState().auth.data;

    const res = await axios({
      url: replaceUrlWithPublicUrl(user, `${API_GATEWAY}/v2/mobile/tribun/feed/pinned`),
      data: body,
      method: 'post',
      headers: {
        channel: '0'
      }
    });
    dispatch({
      type: GET_PINNED_FEED_SUCCESS,
      payload: res.data.feeds,
    });

  } catch (e) {
    dispatch({
      type: GET_PINNED_FEED_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};
